import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Auth from './components/Auth';
import Dashboard from './components/Dashboard';
import AppBuilder from './components/AppBuilder';
import LiveApp from './components/LiveApp';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/dashboard" element={<Auth />} />
        <Route path="/builder/:appId" element={<AppBuilder />} />
        <Route path="/live/:appId" element={<LiveApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;